import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Modal } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import CheckoutForm from '../commanBuyCertificate/checkoutForm';
import { useDispatch, useSelector } from 'react-redux';
import { tenantActions } from '../../../redux/tenant.actions';
import { AntDesign } from '@expo/vector-icons';
const STRIPEKEY = 'pk_live_51MlCEgFCJVtBrQ2WrFpZjfEbieiBD6GaxyoY5mQsOe7Sxfkj6qHvaIMxEshrwCvNnjqV2IJ2SoE0xs8ip6DVlRnc00l6X5Hl3u';
import success from "./../../../../../assets/images/success.svg";
import failed from "./../../../../../assets/images/failed.png";
import { showErrorToast } from '../../helpers';
const ReferencePopUp = (props) => {
  const {
    onClose,
    showModal,
    data,
    onSave
  } = props;
  const [page, setPage] = React.useState(1);
  const stripePromise = loadStripe(STRIPEKEY);
  const [selectedTime, setSelectedTime] = useState('1 Hour');
  const propertyId = useSelector((state) => state?.tenant?.flowIdInfo?.property_id);

  const [cost, setCost] = useState(45);
  const [clientSecret, setClientSecret] = React.useState('');
  useEffect(() => {
    setPage(1)
    setSelectedTime("1 Hour")
    setCost(45)
}, [props?.data]);
  const handleTimeSelection = (time) => {
    setSelectedTime(time);
    switch (time) {
      case '1 Hour':
        setCost(45);
        break;
      case '24 Hours':
        setCost(25);
        break;
      case '48 Hours':
        setCost(20);
        break;
      default:
        setCost(45);
    }
  };
  const dispatch = useDispatch()
  const handleStartReference = () => {

    let data = {
      "hubita_product_id": "id_verification",
      "name": "tenant_id_refrencing",
      "price": cost,
      "is_active": true,
      "amount": cost,
      "property_id": propertyId
    }
    if(props?.data?.guarantors && props?.data?.guarantors?.length){
      data = {
        "hubita_product_id": "id_verification",
        "name": "guarantor_id_refrencing",
        "price": cost,
        "is_active": true,
        "amount": cost,
        "property_id": propertyId
      }
    }
    dispatch(tenantActions.buyFlowPackage(data, (daraaa) => {
      console.log("daraaadaraaa",daraaa)
      if(daraaa?.data?.clientSecret){
        setClientSecret(daraaa?.data?.clientSecret)
        setPage(2)
      }else{
        showErrorToast(typeof(daraaa) === "string"?daraaa: "Something Went wrong!")
      }

    }));
  };
  const renderSuccess = () => {
    return (
      <View style={styles.modalContainer}>
        <img src={success} style={{ height: 100, marginTop: 20 }} />

        <Text
          marginBottom={30}
          marginTop={40}
          style={{ alignSelf: "center", marginBottom: 30, marginTop: 40, fontSize: 26, fontWeight: 700, color: "black" ,textAlign:"center"}}
        >
          Payment Successfull!
        </Text>

        <View style={{ backgroundColor: "#1B8A8C", width: 100, height: 2, alignSelf: "center", marginBottom: 20 }} />
        <TouchableOpacity
          onPress={() => {
            onSave({
              selectedTime, cost
            })

          }}
          style={{
            marginTop: 10,
            paddingHorizontal: 20,
            backgroundColor: "white", borderColor: "#536DFE",
            borderWidth: 1,
            boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
            alignSelf: "center",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 10,
            paddingVertical: 10,
            flexDirection: "row"
          }}
        >
          <Text
            style={{ alignSelf: "center", fontSize: 20, fontWeight: 700, color: "#536DFE" }}
          >
            Continue
          </Text>
          <AntDesign
            style={{ marginLeft: 20 }}
            name="arrowright" size={24} color="#536DFE" />
        </TouchableOpacity>
        <Text
          style={{ marginTop: 30, alignSelf: "center", textAlign: "center", fontSize: 20, fontWeight: 400, color: "black" }}
        >
          Thank you for your payment. Please click continue to buy your rental warrenty.
        </Text>
        <Text
          style={{ marginTop: 10, alignSelf: "center", textAlign: "center", fontSize: 20, fontWeight: 400, color: "black" }}>
          You will receive confirmation of this payment via email.
        </Text>
      </View>
    )
  }
  const renderFail = () => {
    return (
      <View style={styles.modalContainer}>
        <img src={failed} style={{ height: 30, width: 30, alignSelf: "center", marginTop: 20 }} />

        <Text
          marginBottom={30}
          marginTop={40}
          style={{ alignSelf: "center", marginBottom: 30, marginTop: 40, fontSize: 26, fontWeight: 700, color: "black" }}
        >
          Payment Failed!
        </Text>

        <View style={{ backgroundColor: "#1B8A8C", width: 100, height: 2, alignSelf: "center", marginBottom: 20 }} />
        <TouchableOpacity
          onPress={() => {
            setPage(1)
          }}
          style={{
            marginTop: 10,
            paddingHorizontal: 20,
            backgroundColor: "white", borderColor: "#536DFE",
            borderWidth: 1,
            boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
            alignSelf: "center",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 10,
            paddingVertical: 10,
            flexDirection: "row"
          }}
        >
          <Text
            style={{ alignSelf: "center", fontSize: 20, fontWeight: 700, color: "#536DFE" }}
          >
            Retry
          </Text>
          <AntDesign
            style={{ marginLeft: 20 }}
            name="arrowright" size={24} color="#536DFE" />
        </TouchableOpacity>

      </View>
    )
  }
  const renderStripe = () => {
    return (
      <View style={{
        width: "100%",
        maxHeight: "70vh",
        overflow: "scroll"
      }}>
        <Text
          style={{ marginBottom: 30, fontSize: 26, fontWeight: "700", color: "#1B8A8C" }}
        >
          Checkout:
        </Text>
        <View style={{
          borderRadius: 8,
          borderColor: "#1B8A8C",
          borderWidth: 1,
          marginBottom: 30,
          boxShadow: "0px 2px 11px 1px rgba(0,0,0,0.09)",
          padding: 20
        }}>
          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text

              style={{ marginBottom: 30, fontSize: 18, fontWeight: "500", color: "#1B8A8C" }}>
              Enhanced (Full) Response Time:  {selectedTime}
            </Text>


          </View>
          <Text
            style={{ fontSize: 24, fontWeight: "700", color: "#1B8A8C" }}
          >
            Total Cost:  £ {cost.toFixed(2)}
          </Text>
        </View>
        <Elements
          stripe={stripePromise}
          options={{
            clientSecret: clientSecret,
          }}

        >
          <CheckoutForm
            onSuccessToken={(success) => {
              if (success) {
                setPage(3);
              } else {
                setPage(4);
              }
            }}
            onCancel={()=>{
              setPage(1)
            }}
          />
        </Elements>
      </View>
    )
  }
  const renderpage1 = () => {
    return (
      <View style={{ flex: 1 }}>
        <Text style={styles.title}>Reference Request</Text>
        <View style={styles.divider} />

        <Text style={styles.label}>Reference Type:</Text>
        <Text style={styles.referenceType}>Enhanced (Full)</Text>

        <Text style={styles.sectionTitle}>Response Time</Text>
        <View style={styles.radioGroup}>
          {['1 Hour', '24 Hours', '48 Hours'].map((time) => (
            <TouchableOpacity
              key={time}
              style={[
                styles.radioButton,
                selectedTime === time && styles.radioButtonSelected
              ]}
              onPress={() => handleTimeSelection(time)}
            >
              <View style={[
                styles.radioOuter,
                selectedTime === time && styles.radioOuterSelected
              ]}>
                {selectedTime === time && <View style={styles.radioInner} />}
              </View>
              <Text style={[
                styles.radioText,
                selectedTime === time && styles.radioTextSelected
              ]}>
                {time}
              </Text>
            </TouchableOpacity>
          ))}
        </View>

        <View style={styles.costContainer}>
          <Text style={styles.costLabel}>Total Cost:</Text>
          <Text style={styles.cost}>£{cost}</Text>
        </View>

        <View style={styles.buttonContainer}>
          <TouchableOpacity
            onPress={onClose}
            style={styles.cancelButton}
          >
            <Text style={styles.cancelButtonText}>Cancel</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.startButton}
            onPress={handleStartReference}
          >
            <Text style={styles.startButtonText}>Start Reference</Text>
          </TouchableOpacity>
        </View>
      </View>
    )
  }
  return (
    <Modal
      open={showModal ? showModal : false}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <View style={styles.container}>
        {page == 1 ? renderpage1() : null}
        {page == 2 ? renderStripe() : null}
        {page == 3 ? renderSuccess() : null}
        {page == 4 ? renderFail() : null}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 30,
    backgroundColor: '#fff',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowOffset: { width: 0, height: 4 },
    shadowRadius: 8,
    elevation: 5,
    width: "50%",
    minWidth: 400,
    maxWidth: 500,
  },
  title: {
    fontSize: 22,
    fontWeight: '600',
    color: '#333',
    marginBottom: 8,
  },
  divider: {
    height: 1,
    backgroundColor: '#eee',
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    color: '#666',
    marginBottom: 4,
  },
  referenceType: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 16,
  },
  radioGroup: {
    marginBottom: 24,
  },
  radioButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#ddd',
    marginBottom: 8,
    backgroundColor: '#fafafa',
  },
  radioButtonSelected: {
    borderColor: '#8A4FFF',
    backgroundColor: '#f5eeff',
  },
  radioOuter: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#999',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  radioOuterSelected: {
    borderColor: '#8A4FFF',
  },
  radioInner: {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: '#8A4FFF',
  },
  radioText: {
    fontSize: 15,
    color: '#555',
  },
  radioTextSelected: {
    color: '#8A4FFF',
    fontWeight: '500',
  },
  costContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    marginBottom: 24,
  },
  costLabel: {
    fontSize: 16,
    color: '#666',
  },
  cost: {
    fontSize: 20,
    fontWeight: '600',
    color: '#8A4FFF',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
  },
  cancelButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#ddd',
    backgroundColor: '#fff',
  },
  cancelButtonText: {
    fontSize: 15,
    fontWeight: '500',
    color: '#666',
  },
  startButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    backgroundColor: '#8A4FFF',
    alignItems: 'center',
  },
  startButtonText: {
    fontSize: 15,
    fontWeight: '500',
    color: '#fff',
  },
});

export default ReferencePopUp;